import { Plugin } from 'prosemirror-state'
import { InitConfig } from './Types'
import { collabItemWidgetKey } from './constants'
import { CollabItemWidgetView } from 'common/Prose/Plugins/CollabItemWidget/CollabItemWidgetView'

export function collabItemWidget(config: InitConfig) {
  return new Plugin({
    key: collabItemWidgetKey,
    state: {
      init(_) {
        const { store, queryClient } = config
        return {
          store,
          queryClient,
        }
      },
      apply(_, currentPluginState) {
        return currentPluginState
      },
    },
    view(view) {
      return new CollabItemWidgetView(view)
    },
  })
}
